"use client";
import Script from "next/script";

export default function GoogleTranslateHeader() {
    return (
        <>
            <Script
                id="google-translate-init"
                strategy="beforeInteractive" // Ensures the function is ready before the script loads
                dangerouslySetInnerHTML={{
                    __html: `
            window.googleTranslateElementInit = function () {
              new google.translate.TranslateElement(
                { pageLanguage: "en", includedLanguages: "fr,de,es", autoDisplay: true },
                "google_translate_element"
              );
            };
          `,
                }}
            />
            <Script
                src="//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"
                strategy="afterInteractive" // Ensures it's loaded after hydration
            />
        </>
    );
}
